'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscLearn = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M12 3.35 1 9.7l11 6.35 5-2.89v3.3l-5 2.89-5-2.89v-.99l-2-1.15v3.29l7 4.04 7-4.04V12l2-1.15V19h2V9.7L12 3.35Zm0 10.39L5 9.7l7-4.04 7 4.04-7 4.04Z" })
);

module.exports = SvgMiscLearn;
//# sourceMappingURL=MiscLearn.cjs.js.map
